import { createStoreWithProducer } from '@xstate/store';
import { produce } from 'immer';

export type RecordingDurationStoreContext = {
  /** Appointment the published duration belongs to (guards against stale cross-appointment reads). */
  appointmentId: string | null;
  /** Cumulative recording duration (seconds) currently shown by the on-screen timer. */
  durationSeconds: number;
};

const defaultContext: RecordingDurationStoreContext = {
  appointmentId: null,
  durationSeconds: 0,
};

/**
 * Single source of truth for the recording duration the timer displays. The
 * timer (TranscriptionWaveform) is the sole producer; the short-recording guard
 * reads from here so it can never disagree with the on-screen time.
 */
export const recordingDurationStore = createStoreWithProducer(
  produce,
  defaultContext,
  {
    setRecordingDuration: (
      context,
      event: { appointmentId: string | null; durationSeconds: number },
    ) => {
      context.appointmentId = event.appointmentId;
      context.durationSeconds = event.durationSeconds;
    },
  },
);
